import { render } from "./ViewSharedSnapshot.vue?vue&type=template&id=13b3532e&scoped=true"
import script from "./ViewSharedSnapshot.vue?vue&type=script&lang=js"
export * from "./ViewSharedSnapshot.vue?vue&type=script&lang=js"

import "./ViewSharedSnapshot.vue?vue&type=style&index=0&id=13b3532e&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b3532e"]])

export default __exports__